import Box from '@mui/material/Box'
import { useState } from 'react'
import { Select } from '../../1elements'

const DataTypeDropDown = ({ value, onChange, className, disabled }) => {
  const [options] = useState([
    'Date',
    'Email',
    'Link',
    'ShortText',
    'Number',
    'Phone',
    'LongText',
    'Location'
  ])

  return (
    <Box className={className} sx={(theme) => ({
      display: 'flex',
      marginLeft: '5px',
      minWidth: '140px',
      '& .MuiFormControl-root': {
        '& .Mui-focused': {
          boxShadow: `${theme.boxShadow} !important`
        },
        '&:hover': {
          boxShadow: `${theme.boxShadow} !important`
        },
        '& .MuiSelect-select': {
          lineHeight: '27px',
          padding: '1px 3px'
        }
      }
    })}>
      <Select
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Box>
  )
}

export default DataTypeDropDown
